import React from "react";
import { appUrl } from "../../../constants/url-constants";
import PropTypes from "prop-types";

const SchemaBreadCrumbs = ({ data }) => {

    const renderList = () => (
        data.map((item, index) => (
            {
                "@type": "ListItem",
                "position": index + 1,
                "item": {
                    "name": item.displayText,
                    ...(item.redirectURL && { "@id": `${appUrl()}${item.redirectURL}`})
                }
            }
        ))
    );

    return (
        <script type="application/ld+json" dangerouslySetInnerHTML={{
            __html: JSON.stringify(

                {
                    "@context": "http://schema.org",
                    "@type": "BreadcrumbList",
                    "itemListElement": renderList()
                }
            )
        }} />
    );
};

SchemaBreadCrumbs.propTypes = {
    data: PropTypes.array
};

export default SchemaBreadCrumbs;
